import React from 'react';
import Layout from '../../components/Layout';
import ViewportComponent from '../../components/viewportDetail';
import { Link, useParams } from "react-router-dom";

const Viewport = () => {
  const [token, setToken] = React.useState(null)
  const [show, setShow] = React.useState(false)

  React.useEffect(() => {
      if (window) { 
         let t = window.localStorage.getItem('token')
         
         if (t == null) {
             window.location.href = '/login'
         } else {
              setToken(t)
              setShow(true)
         }

      }
  }, []);

  let id = useParams().id;

  let content = (
    <Layout title="Viewport">
    <ViewportComponent token={token} id={id} />
  </Layout>
  )
  
  return (
    <>{show ? content : null}</>
  );
};

export default Viewport;
